<template>
  <div v-if="category && category.length">
    <select
      v-model="cate1"
      class="input select"
      @change="onChangeCate1">
      <option
        v-for="(cate, index) in category"
        :key="index"
        :value="cate.categoryId">
        {{ cate.categoryId === 'call-staff' ? locale['call-staff']
          : cate.categoryId === 'unknown' ? 'unknown'
            : cate.categoryLabel[defaultLang] }}
      </option>
    </select>

    <select
      v-if="subCategory && subCategory.length"
      v-model="cate2"
      class="input select"
      @change="onChangeCate2">
      <option
        v-for="(cate, index) in subCategory"
        :key="index"
        :value="cate.categoryId">
        {{ cate.categoryLabel[defaultLang] }}
      </option>
    </select>
  </div>
</template>

<script>
export default {
  name: 'ShopPageCateogry',
  props: [
    'locale',
    'categoryId',
    'category'
  ],
  data () {
    return {
      cate1: '',
      cate2: '',
      isSyncingFromRoute: false
    }
  },
  computed: {
    defaultLang () {
      const langInfo = this.$store.state.setting.lang
      return langInfo.default
    },
    subCategory () {
      const mainCategory = (this.category || []).find(x => x.categoryId === this.cate1)
      return mainCategory && mainCategory.subCategory ? mainCategory.subCategory : []
    },
    isUnknown () {
      return this.categoryId === 'unknown'
    }
  },
  watch: {
    category: {
      immediate: true,
      handler (category) {
        if (!category || !category.length) return
        this.syncFromCategoryId(this.categoryId)
      }
    },
    categoryId: {
      immediate: true,
      handler (categoryId) {
        if (!this.category || !this.category.length) return
        this.syncFromCategoryId(categoryId)
      }
    }
  },
  methods: {
    syncFromCategoryId (categoryId) {
      this.isSyncingFromRoute = true

      if (categoryId === 'unknown') {
        this.cate1 = 'unknown'
        this.cate2 = ''
        this.$nextTick(() => {
          this.isSyncingFromRoute = false
        })
        return
      }

      if (categoryId === 'call-staff') {
        this.cate1 = 'call-staff'
        this.cate2 = ''
        this.$nextTick(() => {
          this.isSyncingFromRoute = false
        })
        return
      }

      const foundMain = (this.category || []).find(x => x.categoryId === categoryId)
      if (foundMain) {
        this.cate1 = foundMain.categoryId
        this.cate2 = ''
        this.$nextTick(() => {
          this.isSyncingFromRoute = false
        })
        return
      }

      for (const main of this.category || []) {
        const subList = main.subCategory || []
        const foundSub = subList.find(x => x.categoryId === categoryId)

        if (foundSub) {
          this.cate1 = main.categoryId
          this.cate2 = foundSub.categoryId
          this.$nextTick(() => {
            this.isSyncingFromRoute = false
          })
          return
        }
      }

      this.cate1 = ''
      this.cate2 = ''

      this.$nextTick(() => {
        this.isSyncingFromRoute = false
      })
    },

    onChangeCate1 () {
      if (this.isSyncingFromRoute) return

      const mainCategory = (this.category || []).find(x => x.categoryId === this.cate1)

      if (!mainCategory) {
        if (this.cate1 === 'unknown' || this.cate1 === 'call-staff') {
          this.cate2 = ''
          this.$router.replace({
            params: {
              categoryId: this.cate1
            }
          })
          this.$emit('changeCategory')
        }
        return
      }

      const firstSubCategory = mainCategory.subCategory && mainCategory.subCategory.length
        ? mainCategory.subCategory[0].categoryId
        : ''

      this.cate2 = firstSubCategory

      this.$router.replace({
        params: {
          categoryId: firstSubCategory || mainCategory.categoryId
        }
      })

      this.$emit('changeCategory')
    },

    onChangeCate2 () {
      if (this.isSyncingFromRoute) return

      this.$router.replace({
        params: {
          categoryId: this.cate2 || this.cate1
        }
      })

      this.$emit('changeCategory')
    }
  }
}
</script>